import { useContext } from "react";
import { _etap_plikow, _status_wydania_papieru, _typ_elementu } from "utils/initialvalue";
import { AppContext } from "context/AppContext";
import { TechnologyContext } from "context/TechnologyContext";
import { _status } from "utils/initialvalue";
import { updateAddPrzerwa } from "actions/updateAddPrzerwa";
import { updateAddPrzerwaMagic } from "actions/updateAddPrzerwaMagic";
import { dragDropProcesGrupa } from "actions/dragDropProcesGrupa";
import { useGant } from "../useGant";
import { dragDropProcesGrupaGant } from "actions/dragDropProcesGrupaGant";
import DecodeToken from "pages/Login/DecodeToken";
import { dragDropProcesGrupaOprawaGant } from "actions/dragDropProcesGrupaOprawaGant";
import { dragDropProcesGrupaToProcesorGant } from "actions/dragDropProcesGrupaToProcesorGant";

export function useDragDropGant(){
  const techContext = useContext(TechnologyContext);
  const selectedProcesor = techContext.selectedProcesor;
  const appContext = useContext(AppContext);
  const fechGrupyAndWykonaniaForProcesor = techContext.fechGrupyAndWykonaniaForProcesor;
    const [refreshGant, refreshGantAll, refreshGantZakonczone] = useGant();
  

  //========================================================================================================

  function handleDrop(stage,event) {
event.preventDefault();


// 1. Odczyt jako zwykły tekst (np. ID)
  // const draggedItemId = event.dataTransfer.getData("text/plain");
  
  // 2. Odczyt złożonych danych (np. cały obiekt z JSON.parse)
  const rawData = event.dataTransfer.getData("application/json");
  const draggedItem = rawData ? JSON.parse(rawData) : null;

  // console.log("Przeciągnięty ID:", draggedItemId);
  // console.log("Przeciągnięty obiekt:", draggedItem);
  // console.log("Przeciągnięty obiekt:", draggedItem.proces_nazwa_id);

    if (DecodeToken(sessionStorage.getItem("token")).id == 1) {




//-----------------  wszystkie procesy poza oprawą
      if (draggedItem.proces_nazwa_id != 6) {

        // zmiana kolejnosci w obrębie jednego procesora bez oprawy
        if (stage.procesor_id == draggedItem.procesor_id) {
          if (draggedItem.proces_nazwa_id != null) {

            //grupy_wykonan
            let id_drag_grupa_proces = draggedItem.global_id;
            let id_drop_grupa_proces = stage.global_id;

            dragDropProcesGrupaGant(
              id_drag_grupa_proces,
              id_drop_grupa_proces,
              refreshGantAll,
            );

          }
        }



                // zmiana kolejnosci różne procesory w tym samym procesie
                // nie można wrzucić przerwy
        if (stage.procesor_id != draggedItem.procesor_id && draggedItem.typ_grupy ==2) {
          if (draggedItem.proces_nazwa_id != null) {
            //grupy_wykonan
            let global_id_drag = draggedItem.global_id;
            let global_id_drop = stage.global_id;

            let procesor_id_drag = draggedItem.procesor_id;
            let procesor_id_drop = stage.procesor_id;

// console.log("Typ_grupy: "+draggedItem.typ_grupy )
            dragDropProcesGrupaToProcesorGant(global_id_drag,procesor_id_drop,global_id_drag,global_id_drop,procesor_id_drag,procesor_id_drop, refreshGantAll);
          }
        }






      }
//-----------------




//----------------- oprawa
      if (draggedItem.proces_nazwa_id == 6) {
        // if (stage.proces_nazwa_id == draggedItem.proces_nazwa_id) {

        // zmiana kolejnosci w obrębie jednego procesora bez oprawy
        if (stage.procesor_id == draggedItem.procesor_id) {
          if (draggedItem.proces_nazwa_id != null) {

            let id_drag_grupa_proces = draggedItem.global_id;
            let id_drop_grupa_proces = stage.global_id;
            dragDropProcesGrupaOprawaGant(
              id_drag_grupa_proces,
              id_drop_grupa_proces,
              refreshGantAll,
            );
          }
        }
      }
//-----------------




    }






    

  }

  //========================================================================================================

  function handleDragOver(stage,event) {
    let proces_nazwa_id = sessionStorage.getItem("proces_nazwa_id");

    // drag i drop musi być w zakresie jednego procesu 
    if(parseInt(proces_nazwa_id)==parseInt(stage.proces_nazwa_id)){
      event.preventDefault();
    }
  
  }

  //========================================================================================================

  function handleDragStart(stage,event) {
    sessionStorage.setItem("proces_nazwa_id", stage.proces_nazwa_id);
    // sessionStorage.setItem("typ_drag", "grupa_proces");
    // sessionStorage.setItem("typ_grupy", typ_grupy);

    // event.dataTransfer.setData("text/plain", item.id);
    event.dataTransfer.setData("application/json", JSON.stringify(stage));
  }

  //========================================================================================================
  



  return {handleDrop,handleDragOver,handleDragStart};
}

